/**
 * DigiBox portal login — vault design system, no Ant Design.
 * Calls POST /api/auth/portal-login, sets session cookie,
 * then redirects to /digibox (Refine's Authenticated guard passes).
 */

import React, { useState, FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import "@/styles/digibox-vault.css";

export const DigiBoxLogin: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await fetch("/api/auth/portal-login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();

      if (data.success) {
        // Store portal session info for contact-scoped queries
        localStorage.setItem(
          "portal_session",
          JSON.stringify({
            contactId: data.contactId,
            contactName: data.contactName,
            contactEmail: email,
            userId: data.userId,
          })
        );
        // Also set as "user" for Refine's getIdentity
        localStorage.setItem(
          "user",
          JSON.stringify({
            id: data.contactId,
            username: email,
            firstName: data.contactName.split(" ")[0] || "",
            lastName: data.contactName.split(" ").slice(1).join(" ") || "",
            email,
            isPortal: true,
          })
        );
        navigate("/digibox");
      } else {
        setError(data.message || "Credenziali non valide");
      }
    } catch {
      setError("Errore di connessione");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="vault-layout" style={{ gridTemplateColumns: "1fr", gridTemplateRows: "1fr" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh", background: "var(--vault-bg)" }}>
        <div style={{ width: "100%", maxWidth: 400, border: "1px solid var(--vault-grid-line)", padding: "var(--vault-spacing-lg) var(--vault-spacing-md)" }}>
          <div style={{ marginBottom: "var(--vault-spacing-xs)" }}>
            <span className="vault-label-tiny" style={{ fontSize: "1.5rem", letterSpacing: "-0.5px" }}>
              DSGN <b style={{ fontWeight: 500 }}>VAULT</b>
            </span>
          </div>
          <p className="vault-text-muted" style={{ marginBottom: "var(--vault-spacing-md)" }}>
            Accedi al tuo archivio documenti
          </p>

          {error && (
            <p style={{ color: "#d32f2f", fontSize: "var(--vault-text-small)", textAlign: "center", marginBottom: "var(--vault-spacing-sm)" }}>
              {error}
            </p>
          )}

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: "var(--vault-spacing-sm)" }}>
              <label className="vault-label-tiny" style={{ display: "block", marginBottom: 6 }}>EMAIL</label>
              <input
                className="vault-modal-input"
                type="email"
                required
                placeholder="la.tua@email.it"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
              />
            </div>
            <div style={{ marginBottom: "var(--vault-spacing-sm)" }}>
              <label className="vault-label-tiny" style={{ display: "block", marginBottom: 6 }}>PASSWORD</label>
              <input
                className="vault-modal-input"
                type="password"
                required
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
              />
            </div>
            <button
              type="submit"
              className="vault-btn"
              disabled={loading}
              style={{ width: "100%", marginTop: "var(--vault-spacing-xs)" }}
            >
              {loading ? "Accesso..." : "Accedi"}
              <span className="vault-btn-arrow">→</span>
            </button>
          </form>

          <p className="vault-text-muted" style={{ textAlign: "center", marginTop: "var(--vault-spacing-md)", fontSize: "var(--vault-text-tiny)" }}>
            Portale riservato ai contatti autorizzati
          </p>
        </div>
      </div>
    </div>
  );
};
